

























import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import formatNumber from '@/shared/filters/format-number';

@Component({
    filters: {
        formatNumber
    }
})
export default class FooterBar extends Vue {
    @Prop({ default: 0 })
    private totalRows!: number;

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }
}
